import type { ChatDocument, ChatMessageDocument } from '@models/chat';
import { useReturns } from 'app/support/hooks/useReturns';
import { useAuth } from 'context/AuthContext';
import RequestMessage from './RequestMessage';
import { getOrderNumFromContent, pickReturnForChat } from './utils';

interface ReturnsMessageProps {
  message: ChatMessageDocument;
  chat: ChatDocument;
}

const REASON_RE = /stating\s+(.+?)\.\s*The order/;

export default function ReturnsMessage({ message, chat }: ReturnsMessageProps) {
  const { userDoc } = useAuth();
  const isSeller = userDoc?.uid === chat.seller_id;

  const { returnsByOrder } = useReturns({
    orderId: chat.order_id,
    uid: userDoc?.uid,
    field: isSeller ? 'seller_id' : 'buyer_id',
  });

  const returnDoc = pickReturnForChat(returnsByOrder, chat.id);
  const reasonFromContent = message.content.match(REASON_RE)?.[1] ?? null;
  const reason = returnDoc?.refund_reason ?? reasonFromContent ?? null;

  const orderNumFromContent = getOrderNumFromContent(message.content);

  return (
    <RequestMessage
      message={message}
      chat={chat}
      label="Return Request"
      reason={reason}
      bodyText={message.content}
      orderNumFallback={orderNumFromContent}
    />
  );
}
